// @flow
import { connect } from 'react-redux'
import { withHandlers, compose } from 'recompose'
import { withRouter } from 'react-router'
import { getFirstNotification } from './selectors'
import { dismissNotification } from './actions'
import type { Notification } from './types'
import withNotification, { type NotificationProps } from './withNotification'
import { NOTIFICATION_TYPE } from './constants'

const bottomNotifications = [
  NOTIFICATION_TYPE.BID_OUTBID,
  NOTIFICATION_TYPE.BID_WINNING,
  NOTIFICATION_TYPE.SAVED_EVENT,
  NOTIFICATION_TYPE.SAVED_ITEM,
  NOTIFICATION_TYPE.SAVED_EVENT_START,
  NOTIFICATION_TYPE.SAVED_ITEM_START
]

const mapState = state => {
  return {
    notification: getFirstNotification(bottomNotifications)(state)
  }
}
const mapDispatch = { dismissNotification }

const withFirstNotificationData = connect(mapState, mapDispatch)

type ConnectProps = {
  notification: ?Notification,
  dismissNotification: (id: string) => Promise<boolean>
}

type ClickHandlerProps = {
  onClick: any => void
}

const withClickHandler = withHandlers({
  onClick: props => e => {
    const { notification, url, history, dismissNotification } = props
    e.preventDefault()
    if (notification) {
      dismissNotification(notification.id)
      if (url) {
        history.push(url)
      }
    }
  },
  onClose: props => e => {
    const { dismissNotification, notification } = props
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    dismissNotification(notification.id)
  }
})

export type ProviderProps = {
  ...ConnectProps,
  ...NotificationProps,
  ...ClickHandlerProps
}

const NotificationProvider = compose(
  withRouter,
  withFirstNotificationData,
  withNotification,
  withClickHandler
)
export default NotificationProvider



// WEBPACK FOOTER //
// ./src/services/notification/NotificationProvider.js